import { Output } from '@angular/core';
import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-button-form-action',
  templateUrl: './button-form-action.component.html',
  styleUrls: ['./button-form-action.component.scss']
})
export class ButtonFormActionComponent implements OnInit {

  @Input() form: FormGroup;
  @Input() valid: boolean = true;
  @Input() salvarButtonTitle = '';
  @Input() cancelarButtonTitle = '';
  @Output() salvarMethod: EventEmitter<any> = new EventEmitter<any>();
  @Output() voltarMethod: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {

  }

  public salvar(): void {
    this.salvarMethod.emit();
  }

  public voltar(): void {
    this.voltarMethod.emit();
  }

  exibeBotaoSalvar() {
    //TODO
    return this.salvarMethod.observers.length > 0;
  }
  exibeBotaoCancelar() {
    //TODO
    return this.voltarMethod.observers.length > 0;
  }
}
